<template>
    <div>
        <!-- <template v-for="(e, i) in props.totalData" :key="i">
            <table>
                <tr>
                    <td style="border: 1px solid pink">
                        <div class="ddd" style="width: 60px">aa &nbsp;</div>
                    </td>
                    <td style="border: 1px solid black; width: 100%">
                        <div class="contents">
                            <div v-if="e.date && e.type !== 'EVENT'" class="mapTt30" style="text-align: left">{{ e.date }}</div>
                            <div style="margin: 0 0 0 40px">
                                <StudyBox :studyData="e" />
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </template> -->

        <ul class="events">
            <template v-for="(e, i) in props.totalData" :key="i">
                <li>
                    <template v-if="e.type == 'EVENT'">
                        <div class="myDot2"></div>
                        <!-- <div v-else class="myDot"></div> -->
                    </template>
                    <template v-else>
                        <div v-if="props?.totalData[i - 1]?.date === props?.totalData[i]?.date" class="myDot2"></div>
                        <div v-else class="myDot"></div>
                    </template>
                    <!-- <div class="myDot2"></div> -->
                    <div class="contents">
                        <template v-if="e.date && e.type !== 'EVENT'">
                            <strong v-if="props?.totalData[i - 1]?.date === props?.totalData[i]?.date" class="mapTt30"></strong>
                            <strong v-else class="mapTt30">{{ e.date }}</strong>
                        </template>
                        <div style="margin: 0 0 0 40px">
                            <StudyBox :studyData="e" />
                        </div>
                    </div>
                </li>
            </template>
        </ul>
    </div>
</template>
<!-- <div v-if="e.data" class="myDot">&nbsp;</div> -->
<!-- <div v-if="!e.data" class="myDot2">&nbsp;</div> -->
<!-- <div :class="[e.data ? 'myDot' : 'myDot2']"></div> -->
<!-- <time class="myDot" /> -->
<script setup>
import { onMounted, ref, watch, defineProps } from 'vue';
import StudyBox from '@/views/userMap/components/studyBox.vue';
const props = defineProps({
    totalData: {
        Type: Object,
    },
});

onMounted(() => {});
////////////////////////////----OnClick----////////////////////////////
</script>

<style scoped lang="scss">
.ddd {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(50%);
    border-radius: 50%;
    background: #c9c9c9;
    border: 1px #ccc solid;
    width: 20px;
    height: 20px;
}
.events {
    margin: 1em;
    width: 100%;
}
.events,
.events *::before,
.events *::after {
    box-sizing: border-box;
}
.events li {
    display: flex;
    width: 100%;
}

.myDot {
    position: relative;
    padding: 0 16px;
}
.myDot2 {
    position: relative;
    padding: 0 16px;
}
.myDot::after {
    content: '';
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    transform: translateX(50%);
    border-radius: 50%;
    background: #ccc;
    border: 1px #ccc solid;
    width: 20px;
    height: 20px;
}
// .myDot2::after {
//     content: '';
//     position: absolute;
//     z-index: 2;
//     right: 0;
//     top: 0;
//     transform: translateX(50%);
//     border-radius: 50%;
//     background: #304294;
//     border: 1px #ccc solid;
//     width: 20px;
//     height: 20px;
// }
// .events time {
//     position: relative;
//     padding: 0 16px;
// }

// .events time::after {
//     content: '';
//     position: absolute;
//     z-index: 2;
//     right: 0;
//     top: 0;
//     transform: translateX(50%);
//     border-radius: 50%;
//     background: #c9c9c9;
//     border: 1px #ccc solid;
//     width: 1rem;
//     height: 1rem;
// }

.events .contents {
    padding: 0 1.5em 1.5em 1.5em;
    position: relative;
    width: 100%;
}

.events .contents::before {
    content: '';
    position: absolute;
    z-index: 1;
    left: 0;
    height: 100%;
    border-left: 1px #ccc solid;
}

.events strong {
    display: block;
    text-align: left;
    font-weight: bold;
    font-size: 1.8vw;
    margin: -12px 0 10px 54px;
}
</style>
